module.exports = __webpack_public_path__ + "img/20_61.fa5889b3.png";